import { cv } from "../data/content";

// Build a fully-styled, animation-free, RTL HTML string for the CV PDF export.
// Compressed to fit in a single A4 page.
export function buildCvPdfHtml() {
  const esc = (s) =>
    String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");

  const itemHtml = (it) => `
    <div style="padding:4px 0;page-break-inside:avoid;break-inside:avoid;">
      <div style="display:flex;justify-content:space-between;align-items:baseline;gap:8px;flex-wrap:wrap;">
        <div style="flex:1 1 60%;min-width:0;">
          <span style="font-family:'Rubik','Heebo',sans-serif;font-weight:700;font-size:10.5px;line-height:1.2;">${esc(it.role)}</span>
          ${it.place ? `<span style="font-size:9.5px;color:#505050;margin-inline-start:6px;">— ${esc(it.place)}</span>` : ""}
        </div>
        ${it.period ? `<div style="font-size:9px;color:#FF1493;font-weight:600;flex-shrink:0;white-space:nowrap;">${esc(it.period)}</div>` : ""}
      </div>
      ${
        it.bullets && it.bullets.length
          ? `<ul style="margin:2px 0 0;padding:0;list-style:none;">${it.bullets
              .map(
                (b) => `
                <li style="font-size:9px;line-height:1.35;margin-bottom:1px;position:relative;padding-inline-start:9px;">
                  <span style="position:absolute;inset-inline-start:0;top:5px;width:3px;height:3px;border-radius:50%;background:#FF1493;display:inline-block;"></span>
                  ${esc(b)}
                </li>`
              )
              .join("")}</ul>`
          : ""
      }
    </div>`;

  const sectionHtml = (title, inner) => `
    <section style="margin-top:8px;page-break-inside:avoid;break-inside:avoid;">
      <h2 style="font-family:'Rubik','Heebo',sans-serif;font-weight:900;font-size:12px;margin:0;padding-bottom:2px;border-bottom:1px solid rgba(0,0,0,0.35);letter-spacing:-0.01em;">
        ${esc(title)} <span style="color:#FF1493;">✦</span>
      </h2>
      <div style="margin-top:4px;">${inner}</div>
    </section>`;

  const sectionsHtml = cv.sections
    .map((s) => sectionHtml(s.title, s.items.map(itemHtml).join("")))
    .join("");

  return `
    <div dir="rtl" lang="he" style="font-family:'Heebo',Arial,sans-serif;color:#0F0F0F;background:#ffffff;padding:14px 18px;width:740px;box-sizing:border-box;">
      <div style="display:flex;justify-content:space-between;align-items:flex-end;gap:12px;flex-wrap:wrap;border-bottom:2px solid #0F0F0F;padding-bottom:8px;">
        <div>
          <h1 style="font-family:'Rubik','Heebo',sans-serif;font-weight:900;font-size:28px;line-height:1;margin:0;letter-spacing:-0.02em;">
            ${esc(cv.profile.name)}<span style="color:#FF1493;">.</span>
          </h1>
          <p style="font-family:'Frank Ruhl Libre',Georgia,serif;font-style:italic;font-size:12px;color:#505050;margin:3px 0 0;">${esc(cv.profile.role)}</p>
        </div>
        <div style="display:flex;gap:6px;flex-wrap:wrap;font-size:9.5px;">
          <span dir="ltr" style="border:1px solid #0F0F0F;padding:3px 8px;border-radius:999px;">☎ ${esc(cv.profile.phone)}</span>
          <span style="border:1px solid #0F0F0F;padding:3px 8px;border-radius:999px;">✉ ${esc(cv.profile.email)}</span>
        </div>
      </div>
      ${sectionHtml(cv.summary.title, `<p style="font-size:10px;line-height:1.45;margin:0;">${esc(cv.summary.text)}</p>`)}
      ${sectionsHtml}
    </div>
  `;
}
